import React, { useEffect } from 'react';
import { notification } from 'antd';

const ErrorNotification = ({
  type ="success",
  title = "Error Title",
  message = "Something went wrong",
  isopen = false
}) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (isopen) {
      api[type]({
        message: title,
        description: message,
      });
    }
  }, [isopen, title, message, api]);

  return <>{contextHolder}</>;
};

export default ErrorNotification;
